import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

const useSearchParams = () => {
  const { search } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => {
    const params = new URLSearchParams(search);
    return Object.fromEntries(params.entries());
  }, [search]);

  const setSearchParams = (param) => {
    const params = new URLSearchParams(param);
    history.replace({ search: `?${params.toString()}` });
  };

  return [searchParams, setSearchParams];
};

export default useSearchParams;
